import React, {useEffect} from "react";
import { Outlet } from "react-router-dom";
import useAppUrl from "../../../hooks/useAppUrl";
import { MainContainer } from "./Layout.style";

const PengLayout = () => {
  const { appPath, setAppPath, appName, setAppName } = useAppUrl();
  useEffect(() => {
    setAppName("Прописи на енглеском");
    setAppPath("/peng");
  }, [])
  
  return (
    <>
      <MainContainer>
        <Outlet />
      </MainContainer>
    </>
  );
};

export default PengLayout;
